import { caract_anteproyecto_antecedentes } from '../../../models/caract_anteproyecto_antecedentes.model';
import { Component } from "@angular/core";
import { FormControl, FormGroup } from '@angular/forms';
import { FormService } from 'src/app/services/form.service';
import { MatDatepickerInputEvent } from '@angular/material';
import * as moment from 'moment'

@Component({
  selector: 'app-caract-anteproyecto-antecedentes',
  templateUrl: './caract-anteproyecto-antecedentes.component.html',
  styleUrls: ['./caract-anteproyecto-antecedentes.component.css'],
  providers: [FormService]
})
export class CaractAnteproyectoAntecedentesComponent {
  public rows = [];
  public actualRow;
  public caract_anteproyecto_antecedentes: caract_anteproyecto_antecedentes;
  public form;
  public matcher = new FormService();
  public formNumber;
  public formulario;

  public form133 = false;
  public form154 = false;
  public form115 = false


  public fecha;
  public maxDate;
  public tipo_alt;
  public tipo_rec;
  public alteracionSupresionAdicion = false;
  public alteracionResRemReh = false;

  constructor() {

    this.formulario = localStorage.getItem("form")


    if (this.formulario == "1-3.3") {
      this.form133 = true;

    }
    if (this.formulario == "1-5.4") {
      this.form154 = true;

    }
    if (this.formulario == "1-1.5") {
      this.form115 = true;

    }


    this.maxDate = moment().toDate()

    this.form = new FormGroup({
      origen_permiso: new FormControl(''),
      proyecto_radicacion: new FormControl(''),
      tipo_proyectado: new FormControl(''),
      indicar_siIncluye: new FormControl(''),
      cantidad_viviendas: new FormControl(''),
      tipo_proyectado_modificado: new FormControl(''),
      indicar_siIncluye_modificado: new FormControl(''),
      cantidad_viviendas_modificado: new FormControl(''),

    })

    if (!JSON.parse(localStorage.getItem("caract_anteproyecto_antecedentes"))) {
      localStorage.setItem("caract_anteproyecto_antecedentes", JSON.stringify(this.rows));
    } else {
      this.rows = JSON.parse(localStorage.getItem("caract_anteproyecto_antecedentes"));
      this.form.controls['origen_permiso'].setValue(this.rows[0] ? this.rows[0].origen_permiso : '');
      this.form.controls['proyecto_radicacion'].setValue(this.rows[0] ? this.rows[0].proyecto_radicacion : '');
      this.form.controls['tipo_proyectado'].setValue(this.rows[0] ? this.rows[0].tipo_proyectado : '');
      this.form.controls['indicar_siIncluye'].setValue(this.rows[0] ? this.rows[0].indicar_siIncluye : '');
      this.form.controls['cantidad_viviendas'].setValue(this.rows[0] ? this.rows[0].cantidad_viviendas : '');
      this.form.controls['tipo_proyectado_modificado'].setValue(this.rows[0] ? this.rows[0].tipo_proyectado_modificado : '');
      this.form.controls['indicar_siIncluye_modificado'].setValue(this.rows[0] ? this.rows[0].indicar_siIncluye_modificado : '');
      this.form.controls['cantidad_viviendas_modificado'].setValue(this.rows[0] ? this.rows[0].cantidad_viviendas_modificado : '');


    }
    this.caract_anteproyecto_antecedentes = {
      origen_permiso: "",
      proyecto_radicacion: "",
      tipo_proyectado: "",
      indicar_siIncluye: "",
      cantidad_viviendas: "",
      tipo_proyectado_modificado: "",
      indicar_siIncluye_modificado: "",
      cantidad_viviendas_modificado: "",
    };

  }

  add_caract_anteproyecto_antecedentes() {


    localStorage.setItem("caract_anteproyecto_antecedentes", JSON.stringify([]));
    this.actualRow = localStorage.getItem("caract_anteproyecto_antecedentes");
    this.rows = JSON.parse(this.actualRow);
    this.rows = this.rows.concat({
      origen_permiso:this.form.value.origen_permiso,
      proyecto_radicacion: this.form.value.proyecto_radicacion,
      tipo_proyectado:this.form.value.tipo_proyectado,
      indicar_siIncluye: this.form.value.indicar_siIncluye,
      cantidad_viviendas: this.form.value.cantidad_viviendas,
      tipo_proyectado_modificado:this.form.value.tipo_proyectado_modificado,
      indicar_siIncluye_modificado: this.form.value.indicar_siIncluye_modificado,
      cantidad_viviendas_modificado: this.form.value.cantidad_viviendas_modificado

    })
    localStorage.setItem("caract_anteproyecto_antecedentes", JSON.stringify(this.rows));

  }

  delete_caract_anteproyecto_antecedentes(id) {
    for (let x = 0; x < this.rows.length; x++) {
      if (id == x) {
        this.rows.splice(x, 1);
        localStorage.setItem("caract_anteproyecto_antecedentes", JSON.stringify(this.rows));
      }
    }
  }

  onNgModelChangeAlt(event) {
    console.log('on ng model change', event)


    this.tipo_alt = event
    this.add_caract_anteproyecto_antecedentes()
  }

}
